<template>
  <v-card tile>
    <v-card-title class="grey lighten-2">
      Ta bort tågvändning
    </v-card-title>

    <v-card-text class="mt-4">
      <p>
        Är du säker på att du vill ta bort tågvändningen?
      </p>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer />
      <v-btn rounded @click="closeModal">Avbryt</v-btn>
      <v-btn
        rounded
        type="submit"
        color="error"
        @click="onDelete"
        :loading="deletePending"
      >
        Ta bort
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'TurnaroundDeleteModal',

  props: {
    item: Object
  },

  data: () => ({
    deletePending: false
  }),

  methods: {
    async onDelete() {
      this.deletePending = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: DeleteTurnaroundInput!) {
            deleteTurnaround(payload: $payload) {
              deleted_turnaround_uuid
            }
          }
        `,
        variables: {
          payload: {
            uuid: this.item.uuid
          }
        }
      })

      this.deletePending = false
      this.$store.set(`turnaround/data@${this.item.uuid}.deleted`, 1)
      this.closeModal()
    },

    closeModal() {
      this.$emit('close')
    }
  }
}
</script>
